<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-2">
    <i class="fal fa-home"></i>
    <ng-container i18n>Combine Rentals to Multi-Unit</ng-container>
    <app-page-help articleId="cWz1SL2PRXdzh49of4tSkS" videoId=""></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body p-0">
  <div class="d-flex align-items-start gap-3 p-3" style="background: #fcfcfd">
    <img src="/assets/images/rental-group/multi-unit-3.svg" alt="" width="100" />
    <div class="flex-1">
      <h6 i18n class="mb-1">Easily Combine Multiple Rentals into a Multi-Unit Setup</h6>
      <div i18n class="text-sm text-muted">
        Combine multiple rentals into one main listing while keeping each subunit bookable with its own pricing,
        availability, and details. The main unit acts as a grouping structure.
      </div>

      <div class="alert alert-secondary-warning2 text-warning2 mb-0 mt-1 p-2">
        <div i18n class="text-semi-bold">For example:</div>
        <div i18n>
          A resort with beachfront cottages can be a Multi-Unit, letting guests book individually under one listing.
        </div>
      </div>
    </div>
  </div>
  <div class="p-3 border-top border-bottom">
    <app-rental-select
      [ctrl]="form.get('multi_unit_id')"
      [multiple]="false"
      [rentals$]="availableParents$"
      label="Select Main Unit"
      placeholder="Main Unit"
      infoIcon="far fa-question-circle"
      matTooltip="Choose the main unit that will group the selected subunits under a single listing. The main unit itself will not be bookable."
      i18n-matTooltip
    >
    </app-rental-select>

    <app-rental-select
      [ctrl]="form.get('children')"
      [multiple]="true"
      [rentals$]="availableChildren$"
      label="Select Subunits"
      placeholder="Subunits"
      matTooltip="Select the rentals to combine as subunits under the main unit. Each subunit will remain independently bookable with its own pricing and availability."
      infoIcon="far fa-question-circle"
      i18n-matTooltip
      [isSelectable]="isSubunitSelectable"
      [getTooltip]="getTooltip"
    >
    </app-rental-select>
  </div>

  <div class="p-3" style="background: #fcfcfd">
    <div i18n>Preview:</div>
    <ul class="list-unstyled d-flex flex-column mb-0 overflow-auto" style="row-gap: 1px; max-height: 200px">
      <li
        *ngIf="parentIdCtrl.value"
        class="d-flex align-items-center gap-2 position-relative bg-active text-truncate"
        #parentRow
        style="min-height: 30px; padding: 0 25px 0"
      >
        <app-rental-group-label
          label="Multi"
          labelClass="bg-indigo text-white"
          [height]="parentRow.offsetHeight"
          class="position-absolute fw-normal"
          [style.left.px]="-7"
        ></app-rental-group-label>
        <div class="text-truncate">
          {{ parentIdCtrl.value | rentalName | async }}
          <span i18n class="text-light text-sm">(Main Unit)</span>
        </div>
      </li>
      <li
        *ngFor="let id of form.get('children').value"
        class="d-flex align-items-center gap-2 position-relative bg-default text-truncate"
        #childRow
        style="min-height: 30px; padding: 0 25px 0"
      >
        <app-rental-group-label
          label="Sub"
          labelClass="text-indigo bg-secondary-indigo"
          [height]="childRow.offsetHeight"
          class="position-absolute fw-normal"
          [style.left.px]="-7"
        ></app-rental-group-label>
        <div class="text-truncate">{{ id | rentalName | async }}</div>
      </li>
    </ul>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    Cancel
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info" [disabled]="loading$ | async">
    <span class="cs-icon cs-icon-save" *ngIf="!(loading$ | async)"></span>
    <span class="far fa-spinner fa-spin" *ngIf="loading$ | async"></span>
    Save
  </button>
</div>
